import { getInvoicesQUERY } from "../repositorios/Finanzas.queries";

export const getInvoicesCiclo = (ciclo) => getInvoicesQUERY(ciclo);
